var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "border-b border-gray-200 relative" }, [
      _c("div", { staticClass: "sm:flex sm:items-baseline" }, [
        _c(
          "h3",
          {
            staticClass: "text-lg font-medium leading-6 text-gray-900 font-lato"
          },
          [_vm._v("\n        Účet\n      ")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "mt-4 sm:mt-0 sm:ml-10" }, [
          _c(
            "nav",
            { staticClass: "-mb-px flex space-x-8" },
            _vm._l(_vm.tabs, function(tab) {
              return _c(
                "p",
                {
                  key: tab.name,
                  staticClass: "cursor-pointer",
                  class: [
                    tab.id === _vm.currentTab
                      ? "border-brandRed text-brandRed"
                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300",
                    "whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm"
                  ],
                  on: {
                    click: function($event) {
                      _vm.currentTab = tab.id
                    }
                  }
                },
                [_vm._v("\n            " + _vm._s(tab.name) + "\n          ")]
              )
            }),
            0
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass:
            "absolute right-0 top-0 text-xs text-gray-500 hover:text-gray-700 cursor-pointer",
          on: { click: _vm.logout }
        },
        [_vm._v("\n      Odhlásit\n    ")]
      )
    ]),
    _vm._v(" "),
    _c("div", [
      _vm.currentTab === "orders"
        ? _c(
            "div",
            [
              _c("orders-table", {
                attrs: { orders: _vm.orders, "detail-id": _vm.detailId }
              })
            ],
            1
          )
        : _vm.currentTab === "addresses"
        ? _c(
            "div",
            [
              _c("address-fields", {
                attrs: {
                  address: _vm.localBilling,
                  email: _vm.email,
                  type: "billing"
                },
                on: {
                  update: function(address) {
                    return (_vm.localBilling = address)
                  }
                }
              })
            ],
            1
          )
        : _vm.currentTab === "password"
        ? _c("div", [_c("change-password")], 1)
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/matej/Works/Code/mago/wp-content/themes/sage/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/matej/Works/Code/mago/wp-content/themes/sage/node_modules/vue-loader/lib?{}!./scripts/vue/auth/Account.vue?vue&type=template&id=63cc003a&
// module id = 174
// module chunks = 0